import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";

const CardFormPage = ({ onBack, onCancel, onSubmit, isLoading, errorMessage }) => {
  const [cardData, setCardData] = useState({
    cardNumber: "",
    cardHolder: "",
    expiryDate: "",
    cvv: "",
    document: "",
    email: "",
  });
  const [errors, setErrors] = useState({});

  const formatCardNumber = (value) => {
    const digits = value.replace(/\D/g, "");
    const parts = [];
    for (let i = 0; i < digits.length; i += 4) {
      parts.push(digits.slice(i, i + 4));
    }
    return parts.join(" ");
  };

  const formatExpiryDate = (value) => {
    const digits = value.replace(/\D/g, "");
    if (digits.length <= 2) return digits;
    return `${digits.slice(0, 2)}/${digits.slice(2, 4)}`;
  };

  const validateForm = () => {
    const newErrors = {};
    if (
      !cardData.cardNumber ||
      cardData.cardNumber.replace(/\D/g, "").length !== 16
    ) {
      newErrors.cardNumber = "Número do cartão inválido (deve ter 16 dígitos)";
    }
    if (!cardData.cardHolder || cardData.cardHolder.trim().length < 3) {
      newErrors.cardHolder = "Nome do titular inválido";
    }
    if (
      !cardData.expiryDate ||
      !/^\d{2}\/\d{2}$/.test(formatExpiryDate(cardData.expiryDate))
    ) {
      newErrors.expiryDate = "Data de validade inválida (MM/AA)";
    }
    if (!cardData.cvv || !/^\d{3,4}$/.test(cardData.cvv)) {
      newErrors.cvv = "CVV inválido (3 ou 4 dígitos)";
    }
    const cleanDoc = cardData.document.replace(/\D/g, "");
    if (!cleanDoc || (cleanDoc.length !== 11 && cleanDoc.length !== 14)) {
      newErrors.document = "CPF (11 dígitos) ou CNPJ (14 dígitos) inválido";
    }
    if (!cardData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cardData.email)) {
      newErrors.email = "E-mail inválido";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      onSubmit(
        {
          ...cardData,
          cardNumber: cardData.cardNumber.replace(/\D/g, ""),
          expiryDate: cardData.expiryDate.replace(/\D/g, ""),
        },
        null
      );
    }
  };

  const inputBaseStyle = {
    width: "100%",
    padding: "10px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    fontSize: "16px",
    outline: "none",
    boxShadow: "none",
    transition: "border-color 0.3s",
  };

  return (
    <div className="modal" style={{ width: "425px" }}>
      <button
        className="close"
        onClick={onCancel}
        style={{
          cursor: "pointer",
          position: "absolute",
          right: "-10px",
          top: "-10px",
          width: "36px",
          height: "36px",
          fontSize: "24px",
          background: "#D11A2A",
          borderRadius: "18px",
          border: "1px solid #cfcece",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          lineHeight: "normal",
          padding: 0,
        }}
      >
        ×
      </button>
      <img className="logo" src={"/img/raidhut.png"} alt="raidhut-logo" />
      <h1 className="modal-title">Dados do Cartão</h1>
      <h3 className="modal-subtext">
        Digite os dados do seu cartão para finalizar o pagamento
      </h3>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "20px",
          color: "#666",
          fontSize: "14px",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#666"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ marginRight: "8px" }}
        >
          <path d="M12 2a10 10 0 0 1 10 10c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2z"></path>
          <path d="M12 16v-4"></path>
          <path d="M12 8h.01"></path>
        </svg>
        Seus dados estão protegidos com criptografia segura
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
          width: "100%",
        }}
      >
        <div>
          <label
            style={{
              display: "block",
              marginBottom: "5px",
              fontSize: "14px",
              color: "#333",
              fontWeight: 500,
            }}
          >
            Número do Cartão
          </label>
          <InputText
            value={formatCardNumber(cardData.cardNumber)}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "").slice(0, 16);
              setCardData({ ...cardData, cardNumber: value });
            }}
            placeholder="9999 9999 9999 9999"
            maxLength="19"
            style={inputBaseStyle}
          />
          {errors.cardNumber && (
            <small style={{ color: "red", fontSize: "12px", display: "block" }}>
              {errors.cardNumber}
            </small>
          )}
        </div>

        <div>
          <label
            style={{
              display: "block",
              marginBottom: "5px",
              fontSize: "14px",
              color: "#333",
              fontWeight: 500,
            }}
          >
            Nome do Titular
          </label>
          <InputText
            value={cardData.cardHolder}
            onChange={(e) =>
              setCardData({ ...cardData, cardHolder: e.target.value })
            }
            placeholder="Nome como aparece no cartão"
            style={inputBaseStyle}
          />
          {errors.cardHolder && (
            <small style={{ color: "red", fontSize: "12px", display: "block" }}>
              {errors.cardHolder}
            </small>
          )}
        </div>

        <div style={{ display: "flex", gap: "15px" }}>
          <div style={{ flex: 1 }}>
            <label
              style={{
                display: "block",
                marginBottom: "5px",
                fontSize: "14px",
                color: "#333",
                fontWeight: 500,
              }}
            >
              Data de Validade
            </label>
            <InputText
              value={formatExpiryDate(cardData.expiryDate)}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "").slice(0, 4);
                setCardData({ ...cardData, expiryDate: value });
              }}
              placeholder="MM/AA"
              maxLength="5"
              style={inputBaseStyle}
            />
            {errors.expiryDate && (
              <small
                style={{ color: "red", fontSize: "12px", display: "block" }}
              >
                {errors.expiryDate}
              </small>
            )}
          </div>

          <div style={{ flex: 1 }}>
            <label
              style={{
                display: "block",
                marginBottom: "5px",
                fontSize: "14px",
                color: "#333",
                fontWeight: 500,
              }}
            >
              CVV
            </label>
            <InputText
              type="password"
              value={cardData.cvv}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "").slice(0, 4);
                setCardData({ ...cardData, cvv: value });
              }}
              placeholder="123"
              maxLength="4"
              style={inputBaseStyle}
            />
            {errors.cvv && (
              <small
                style={{ color: "red", fontSize: "12px", display: "block" }}
              >
                {errors.cvv}
              </small>
            )}
          </div>
        </div>

        {/* CPF/CNPJ e E-mail */}
        <div style={{ display: "flex", gap: "15px" }}>
          <div style={{ flex: 1 }}>
            <label
              style={{
                display: "block",
                marginBottom: "5px",
                fontSize: "14px",
                color: "#333",
                fontWeight: 500,
              }}
            >
              CPF / CNPJ
            </label>
            <InputText
              value={cardData.document}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "").slice(0, 14);
                setCardData({ ...cardData, document: value });
              }}
              placeholder="Somente números"
              maxLength="14"
              style={inputBaseStyle}
            />
            {errors.document && (
              <small style={{ color: "red", fontSize: "12px", display: "block" }}>
                {errors.document}
              </small>
            )}
          </div>

          <div style={{ flex: 1 }}>
            <label
              style={{
                display: "block",
                marginBottom: "5px",
                fontSize: "14px",
                color: "#333",
                fontWeight: 500,
              }}
            >
              E-mail
            </label>
            <InputText
              type="email"
              value={cardData.email}
              onChange={(e) =>
                setCardData({ ...cardData, email: e.target.value })
              }
              placeholder="seu@email.com"
              style={inputBaseStyle}
            />
            {errors.email && (
              <small style={{ color: "red", fontSize: "12px", display: "block" }}>
                {errors.email}
              </small>
            )}
          </div>
        </div>
      </div>

      {errorMessage && (
        <div style={{ color: "#D11A2A", marginTop: "20px", textAlign: "center", fontSize: "14px", fontWeight: "bold" }}>
          {errorMessage}
        </div>
      )}

      <div
        style={{
          display: "flex",
          gap: "10px",
          marginTop: "20px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          label="Voltar"
          onClick={onBack}
          style={{
            borderRadius: "4px",
            border: "1px solid #ccc",
            background: "#f0f0f0",
            color: "#333",
            cursor: "pointer",
            height: "2.8rem",
            display: "flex",
            alignItems: "center",
          }}
        />
        <button
          className="copy-button"
          onClick={handleSubmit}
          disabled={isLoading}
          style={{ position: "relative", width: "280px"}}
        >
          {isLoading ? (
            <>
              <ProgressSpinner
                style={{
                  width: "20px",
                  height: "20px",
                  position: "absolute",
                  left: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
                strokeWidth="8"
                disabled={true}
                hoverable={false}
              />
              Carregando...
            </>
          ) : (
            "Continuar"
          )}
        </button>
      </div>
    </div>
  );
};

export default CardFormPage;
